<template>
	<div class="extension">
		<div><img src="../assets/extension.jpg" alt=""></div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: "extension",
		components: {
			
		},
		data() {
			return {
				
			}
		},
		activated() {

		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			
			
		}

	};
</script>

<style scoped lang="scss">
	.extension {
		min-height: 100vh;
		background-color: #f23a38;
	}
</style>
